import React from 'react';
import { Box, Stack } from '@mui/material';
import InputControl from 'src/components/Shared/Forms/InputControl';
import { useSettingsContext } from 'src/components/settings';

const ColorSetting = () => {
  const settings = useSettingsContext();
  const [forms, setForms] = React.useState({
    bodhiPrimaryColor: settings.bodhiPrimaryColor || '',
    bodhiSecondaryColor: settings.bodhiSecondaryColor || '',
    bodhiPrimaryTextColor: settings.bodhiPrimaryTextColor || '',
    bodhiSecondaryTextColor: settings.bodhiSecondaryTextColor || '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setForms({
      ...forms,
      [name]: value,
    });
  };

  const onBlur = e => {
    const { name } = e.target;
    settings.onUpdate(name, forms[name]);
  };

  return (
    <Box>
      <form>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <Box>
            <InputControl
              label='Primary Color'
              type='color'
              name='bodhiPrimaryColor'
              onChange={handleChange}
              id='bodhiPrimaryColor'
              onBlur={onBlur}
              value={settings.bodhiPrimaryColor || ''}
            />
          </Box>
          <Box>
            <InputControl
              label='Secondary Color'
              type='color'
              name='bodhiSecondaryColor'
              onChange={handleChange}
              id='bodhiSecondaryColor'
              value={settings.bodhiSecondaryColor || ''}
            />
          </Box>
          {/* <Box>
            <InputControl
              label='Background Color'
              type='color'
              name='backgroundColor'
              onChange={handleChange}
              id='backgroundColor'
              value={settings.backgroundColor}
            />
          </Box> */}
          <Box>
            <InputControl
              label='Primary Text Color'
              type='color'
              name='bodhiPrimaryTextColor'
              onChange={handleChange}
              id='bodhiPrimaryTextColor'
              value={settings.bodhiPrimaryTextColor || ''}
            />
          </Box>
          <Box>
            <InputControl
              label='Secondary Text Color'
              type='color'
              name='bodhiSecondaryTextColor'
              onChange={handleChange}
              id='bodhiSecondaryTextColor'
              value={settings.bodhiSecondaryTextColor || ''}
            />
          </Box>
        </Stack>
      </form>
    </Box>
  );
};

export default ColorSetting;
